<template>
  <div class="main_top">
    <div
      class="fixed"
      :class="hasBorder ? 'has_border' : ''"
      :style="'backgroundColor:' + bgColor"
    >
      <div class="top_header" v-if="type == 1">
        <div class="m_flex_box flex_vc flex_jz">
          <p class="header_address m_flex_box flex_vc">
            <span @click="showPicker = true">{{ area | getHostArea }}</span>
          </p>
          <router-link to="/search" class="search_con m_flex_box flex_vc">
            <van-icon name="search" />
            <span class="middle">搜索</span>
          </router-link>
          <router-link to="/newMap" class="to_map m_flex_box flex_vc">
            <img src="@/assets/img/map.png" alt="" />
            <span>地图</span>
          </router-link>
        </div>
      </div>
      <div class="top_header" v-if="type == 2">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="search_con_l m_flex_box flex_vc">
            <van-icon name="search" />
            <input
              class="middle"
              type="text"
              v-model="inpText"
              :placeholder="placeholder ? placeholder : '搜索'"
              @keyup.enter="submit"
            />
          </div>
          <p class="header_address m_flex_box flex_vc">
            <span @click="showPicker = true">{{ area | getHostArea }}</span>
          </p>
        </div>
      </div>
      <div class="top_header top_sm" v-if="type == 3">
        <div
          class="m_flex_box flex_vc top_normal"
          :style="'color:' + textColor"
        >
          <!-- <van-icon name="arrow-left" @click="returnGo"/> -->
          <img
            src="@/assets/img/back_.png"
            alt=""
            class="back_"
            @click="returnGo"
          />
        </div>
      </div>
      <div class="top_header top_sm" v-if="type == 4">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon name="arrow-left" @click="$router.go(-1)" />
            <div class="search_con m_flex_box flex_vc mar_l">
              <van-icon name="search" />
              <input
                class="middle"
                type="text"
                v-model="inpText"
                :placeholder="placeholder ? placeholder : '搜索'"
                @keyup.enter="submit"
              />
            </div>
          </div>
          <p class="header_icon">
            <van-icon name="chat-o" />
          </p>
        </div>
      </div>
      <div class="top_header top_sm" v-if="type == 5 || type == 6">
        <div
          class="m_flex_box flex_vc flex_jz top_normal"
          :style="'color:' + textColor"
        >
          <van-icon name="arrow-left" @click="$router.go(-1)" />
          <p :style="'font-size:' + fontSize">{{ placeholder }}</p>
          <i></i>
        </div>
      </div>

      <div class="top_header top_sm" v-if="type == 15">
        <div
          class="m_flex_box flex_vc flex_jz top_normal"
          :style="'color:' + textColor"
        >
          <van-icon name="arrow-left" @click="goback" />
          <p :style="'font-size:' + fontSize">{{ placeholder }}</p>
          <i></i>
        </div>
      </div>

      <div class="top_header" v-if="type == 7">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc" :style="'color:' + textColor">
            <van-icon name="arrow-left" class="mar_r" @click="$router.go(-1)" />
            <div class="search_con m_flex_box flex_vc">
              <van-icon name="search" />
              <input
                class="middle"
                type="text"
                v-model="inpText"
                :placeholder="placeholder ? placeholder : '搜索'"
                @keyup.enter="submit"
              />
            </div>
          </div>
          <p
            class="header_address m_flex_box flex_vc"
            :class="textColor === '#fff' ? 'white' : ''"
          >
            <span :style="'color:' + textColor" @click="showPicker = true">{{
              area | getHostArea
            }}</span>
          </p>
        </div>
      </div>
      <div class="top_header" v-if="type == 8">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc" :style="'color:' + textColor">
            <van-icon name="arrow-left" class="mar_r" @click="$router.go(-1)" />
            <div class="search_con m_flex_box flex_vc">
              <van-icon name="search" />
              <input
                class="middle"
                type="text"
                v-model="inpText"
                :placeholder="placeholder ? placeholder : '搜索'"
                @keyup.enter="submit"
              />
            </div>
          </div>
          <router-link to="/newMap" class="to_map m_flex_box flex_vc">
            <img src="@/assets/img/map.png" alt="" />
            <span :style="'color:' + textColor">地图</span>
          </router-link>
        </div>
      </div>
      <div class="top_header" v-if="type == 9">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon name="arrow-left" class="mar_r" @click="$router.go(-1)" />
            <div class="search_con m_flex_box flex_vc">
              <van-icon name="search" />
              <input
                class="middle"
                type="text"
                v-model="inpText"
                :placeholder="placeholder ? placeholder : '搜索'"
                @keyup.enter="submit"
              />
            </div>
          </div>
          <p class="header_address m_flex_box flex_vc">
            <span @click="showPicker = true">{{ area | getHostArea }}</span>
          </p>
        </div>
      </div>
      <div class="top_header" v-if="type == 10">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <div class="search_con_l m_flex_box flex_vc">
              <van-icon name="search" />
              <input
                class="middle"
                type="text"
                v-model="getValueImmediately"
                :placeholder="placeholder ? placeholder : '搜索'"
              />
            </div>
          </div>
          <span class="cancel" @click="$router.go(-1)">取消</span>
        </div>
      </div>
      <div class="top_header" v-if="type == 11">
        <div class="m_flex_box flex_vc flex_jz">
          <van-icon name="arrow-left" class="mar_r" @click="$router.go(-1)" />
          <div class="search_con_l m_flex_box flex_vc">
            <van-icon name="search" />
            <input
              class="middle"
              type="text"
              v-model="inpText"
              :placeholder="placeholder ? placeholder : '搜索'"
              @keyup.enter="submit"
            />
          </div>
        </div>
      </div>
      <div class="top_header" v-if="type == 12">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc" :style="'color:' + textColor">
            <van-icon name="arrow-left" class="mar_r" @click="$router.go(-1)" />
            <div class="search_con m_flex_box flex_vc">
              <van-icon name="search" />
              <input
                class="middle"
                type="text"
                v-model="getValueImmediately"
                :placeholder="placeholder ? placeholder : '搜索'"
                @keyup.enter="submit"
              />
            </div>
          </div>
          <p
            class="header_address m_flex_box flex_vc"
            :class="textColor === '#fff' ? 'white' : ''"
          >
            <span :style="'color:' + textColor" @click="showPicker = true">{{
              area | getHostArea
            }}</span>
          </p>
        </div>
      </div>
      <div class="top_header top_sm" v-if="type == 13">
        <div
          class="m_flex_box flex_vc flex_jz top_normal"
          :style="'color:' + textColor"
        >
          <van-icon name="arrow-left" @click="$router.go(-1)" />
          <p :style="'font-size:' + fontSize">{{ placeholder }}</p>
          <p
            class="header_address m_flex_box flex_vc"
            :class="textColor === '#fff' ? 'white' : ''"
          >
            <span :style="'color:' + textColor" @click="showPicker = true">{{
              area | getHostArea
            }}</span>
          </p>
        </div>
      </div>
    </div>
    <div
      class="fixed_pad"
      v-if="isShow && type !== 3 && type !== 4 && type !== 6 && type !== 13"
    ></div>
    <div
      class="fixed_pad_sm"
      v-if="isShow && (type === 4 || type === 6 || type === 13)"
    ></div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="v"
        :columns="areaList"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "topHeader",
  props: {
    type: {
      default: 1,
    },
    placeholder: {
      default: "请输入",
    },
    bgColor: {
      default: "#fff",
    },
    isShow: {
      default: true,
    },
    textColor: {
      default: "#000",
    },
    inputText: {
      default: "",
    },
    hasBorder: {
      default: false,
    },
    fontSize: {
      default: "0.24rem",
    },
  },
  inject: ["reload"],
  data() {
    return {
      area: "主城区",
      inpText: "",
      getValueImmediately: "",
      showPicker: false,
      areaList: [
        {
          v: "主城区",
          url: "https://www.xzhouse.com.cn/page/generation/xzxxw/",
        },
        {
          v: "丰县",
          url: "https://fx.xzhouse.com.cn/page/generation/xzxxw/",
        },
        {
          v: "新沂市",
          url: "https://xy.xzhouse.com.cn/page/generation/xzxxw/",
        },
        {
          v: "睢宁县",
          url: "https://sn.xzhouse.com.cn/page/generation/xzxxw/",
        },
        {
          v: "沛县",
          url: "https://px.xzhouse.com.cn/page/generation/xzxxw/",
        },
        {
          v: "邳州市",
          url: "https://pz.xzhouse.com.cn/page/generation/xzxxw/",
        },
      ],
    };
  },
  filters: {
    getHostArea() {
      var host = document.domain;
      if (host == "www.xzhouse.com.cn") {
        return "主城区"; //主城区
      } else if (host == "fx.xzhouse.com.cn") {
        return "丰县";
      } else if (host == "xy.xzhouse.com.cn") {
        return "新沂";
      } else if (host == "sn.xzhouse.com.cn") {
        return "睢宁";
      } else if (host == "px.xzhouse.com.cn") {
        return "沛县";
      } else if (host == "pz.xzhouse.com.cn") {
        return "邳州";
      } else {
        return "主城区";
      }
    },
  },
  watch: {
    getValueImmediately(n) {
      this.$emit("comfirmText", n);
    },
    inputText(n) {
      if (!n) {
        this.inpText = "";
      }
    },
  },
  mounted() {
    this.area = document.domain;
  },
  methods: {
    onConfirm(data) {
      this.area = data.v;
      window.location.href = data.url + "#" + this.$route.path;
    },
    submit() {
      this.$emit("comfirmText", this.inpText);
    },
    goback(){
      this.$emit("goBack");
    },
    returnGo() {
      this.$router.go(-1);
      this.reload();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.lottery {
  .main_top {
    .fixed {
      top: 30px;
    }
  }
}
.fixed {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
/deep/ .van-icon-arrow-left {
  font-size: 0.32rem;
  &.mar_r {
    margin-right: 0.18rem;
  }
}
.has_border {
  border-bottom: 1px solid #f4f4f4;
}
.mar_l {
  margin-left: 0.2rem;
}
.fixed_pad {
  padding-top: 1.1rem;
}
.fixed_pad_sm {
  padding-top: 0.9rem;
}
.cancel {
  font-size: 0.28rem;
}
.header_address {
  font-size: 0.28rem;
  font-weight: 600;
  cursor: pointer;
  &.white {
    &:after {
      border-color: #fff transparent transparent transparent;
    }
  }
  &:after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0.08rem;
    margin-left: 0.1rem;
    margin-top: 0.08rem;
    border-color: #202020 transparent transparent transparent;
  }
}
.top_header {
  height: 0.7rem;
  padding: 0.2rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
  .back_ {
    width: 0.38rem;
  }
  &.top_sm {
    padding: 0.1rem;
  }
  .search_con,
  .search_con_l {
    background-color: #f6f6f6;
    border: 1px solid #f0f0f0;
    border-radius: 0.7rem;
    height: 0.7rem;
    box-sizing: border-box;
    font-size: 0.26rem;
    padding: 0 0.3rem;
    color: #303030;
    i {
      font-size: 0.36rem;
      margin-right: 0.2rem;
    }
  }
  input {
    width: 80%;
    height: 0.7rem;
    background-color: transparent;
  }
  .search_con {
    width: 4.78rem;
  }
  .search_con_l {
    width: 5.72rem;
  }
  .to_map {
    font-size: 0.28rem;
    img {
      margin-right: 0.06rem;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}
.header_icon {
  font-size: 0.42rem;
}
</style>
